/**
 * Campos de formulário reutilizáveis (pesquisa com lupa e caixa de seleção), compartilhados
 * entre o ERP Web e o CaféGestor Vendedor. Mesmos componentes de antes
 * (`apps/web/src/features/cadastros/widgets.tsx` continua exportando os dois).
 */
import type { Ref } from "react";
import { Icon } from "./icons";
import { Input } from "./primitives";

/** Campo de pesquisa com lupa (mesmo papel de caixa de texto de antes). */
export function SearchInput({
  value,
  onChange,
  placeholder,
  label,
  className = "w-full max-w-sm",
  inputRef,
  inputClassName = "",
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  label?: string;
  className?: string;
  /** para devolver o foco à pesquisa (ex.: depois de incluir um produto) */
  inputRef?: Ref<HTMLInputElement>;
  inputClassName?: string;
}) {
  return (
    <div className={`relative ${className}`}>
      <span className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground">
        <Icon name="search" size={18} strokeWidth={2} />
      </span>
      <Input
        ref={inputRef}
        enterKeyHint="search"
        autoComplete="off"
        className={`pl-11 ${inputClassName}`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        {...(label ? { "aria-label": label } : {})}
      />
    </div>
  );
}

export function Checkbox({
  label,
  checked,
  onChange,
  disabled,
}: {
  label: string;
  checked: boolean;
  onChange: (e: { target: { checked: boolean } }) => void;
  disabled?: boolean;
}) {
  // a caixa nunca encolhe e o texto quebra a linha ao lado dela (sem cortar nem sobrepor),
  // em qualquer largura; a área de toque cobre a linha toda
  return (
    <label className="inline-flex max-w-full min-w-0 cursor-pointer items-start gap-2.5 py-1 text-sm leading-snug has-[:disabled]:cursor-not-allowed">
      <input
        type="checkbox"
        className="mt-px size-[18px] shrink-0 accent-primary"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="min-w-0 break-words">{label}</span>
    </label>
  );
}
